"use client";

import { useStyleController } from "@/hooks/useStyleController.hook";
import classNames from "classnames";
import Image from "next/image";
import blessnetLogo from "@public/bless-green-logo.png";

import BlessButton from "@/components/layout/button/green-outline-btn";
import styles from "./feature-content.module.scss";
import { useUIStore } from "@/stores/ui-states.store";
import Link from "next/link";

const FeatureContent = () => {
  const {
    refControl: { textContainerRef },
  } = useStyleController();

  const { introAnimationCompleted } = useUIStore();

  return (
    <div
      ref={textContainerRef}
      className={classNames(
        styles.textContainer,
        introAnimationCompleted && styles.fadein,
      )}
    >
      <div className={styles.heavy}>
        <i>do</i> things with
      </div>
      <Image src={blessnetLogo} alt="blessnet-logo" />
      <p>
        Safer on-chain vertical scaling for all Ethereum compatible blockchains.
      </p>
      <div className={styles.buttons}>
        <Link href="https://docs.bless.net/">
          <BlessButton buttonType="outlined">Read the docs</BlessButton>
        </Link>
        <Link href="https://bless.net/bridge">
          <BlessButton buttonType="rainbow">Visit the bridge</BlessButton>
        </Link>
      </div>
    </div>
  );
};

export default FeatureContent;
